import { MapTo } from '@adobe/aem-react-editable-components';
import ContactInformation, { ContactInformationEditConfig } from './ContactInformation';

export default MapTo('cob-corp-acquisition/components/creditonebank/contact-information')(ContactInformation,
    ContactInformationEditConfig);